export default __webpack_public_path__ + "static/ui-transfers-2-e14f2cffaa10102511d4c5b1ab4eed57.png";